import { render } from "./CrossTabCart.vue?vue&type=template&id=49a403c5&scoped=true"
import script from "./CrossTabCart.vue?vue&type=script&lang=js"
export * from "./CrossTabCart.vue?vue&type=script&lang=js"

import "./CrossTabCart.vue?vue&type=style&index=0&id=49a403c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a403c5"]])

export default __exports__